import Resource from './Resource';
import type Contact from 'App/resources/Model/Contact';

/**
 * Account-wide email lookup behind the contact forms' duplicate warning. Goes straight to
 * `_getRequest` rather than through `get()`/`find()` so the rows skip the date mappers — this
 * endpoint returns no date fields.
 */
class EmailDuplicates extends Resource {
	constructor() {
		super('function/email-duplicates');
	}

	findDuplicates(clientId: number, excludedId: number | undefined, email: string): Promise<Contact[]> {
		return this._getRequest(String(clientId), {
			methodName: 'findDuplicates',
			params: excludedId ? { email, excludedid: excludedId } : { email }
		}).then((res: { data: { data?: Contact[] | null } }) => res.data.data ?? []);
	}
}

const resource = new EmailDuplicates();

export default resource;
